export type Order = 'asc' | 'desc'
export type OrderBy = 'code' | 'version' | 'updated_at'

export interface HeadCell {
    id: OrderBy
    label: string
    numeric: boolean
    disablePadding?: boolean
}

export const headCells: HeadCell[] = [
    { id: 'code', label: 'Model Code', numeric: false },
    { id: 'version', label: 'Version', numeric: false },
    { id: 'updated_at', label: 'Last Updated', numeric: false }
]

export const parseVersion = (nodeAttributes: string | null | undefined): string => {
    try {
        const attrs = JSON.parse(nodeAttributes || '{}')
        return attrs.version || 'N/A'
    } catch {
        return 'N/A'
    }
}

export const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return 'N/A'

    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })
}

export const matchesSearchFilter = (model: any, searchFilter: string): boolean => {
    if (!searchFilter) return true

    const lowerSearch = searchFilter.toLowerCase()

    if (model.code?.toLowerCase().includes(lowerSearch)) return true

    try {
        const attrs = JSON.parse(model.node_attributes || '{}')
        if (attrs.version?.toLowerCase().includes(lowerSearch)) return true
    } catch {
        // Ignore JSON parse errors
    }

    return false
}

export const matchesStatusFilter = (model: any, statusFilter: string): boolean => {
    if (!statusFilter) return true

    return (
        (statusFilter === 'published' && !model.is_edited) ||
        (statusFilter === 'unpublished' && model.is_edited)
    )
}

export const getSortValue = (model: any, orderBy: OrderBy): any => {
    switch (orderBy) {
        case 'code':
            return model.code || ''
        case 'version':
            try {
                const attrs = JSON.parse(model.node_attributes || '{}')
                return attrs.version || ''
            } catch {
                return ''
            }
        case 'updated_at':
            return new Date(model.updated_at || 0).getTime()
        default:
            return model.code || ''
    }
}

export const compareValues = (aValue: any, bValue: any, order: Order): number => {
    if (typeof aValue === 'string') {
        const comparison = aValue.localeCompare(bValue)
        return order === 'desc' ? -comparison : comparison
    } else {
        return order === 'desc' ? bValue - aValue : aValue - bValue
    }
}
